<app-bar-chart
  [labels]="labels"
  [series]="series"
  [loading]="isLoading"
  [title]="'Semantics Time Series Topic'"
  [chartType]="'bar'"
  [options]="options"
></app-bar-chart>
